<template>
  <div class="card-block bg-grey-800">
    <h3 class="card-title">
    </h3>
    <div class="row" v-if="isLoading && !team">
      <div class="col-md-12 card-stat">
        <loading-indicator></loading-indicator>
      </div>
    </div>
    <div v-else>
      <discount-package
        v-bind:team="team">
      </discount-package>
      <pricing-plan
        v-bind:team="team"
        v-on:loadChanged="pricingPlanLoadChanged">
      </pricing-plan>
      <pay-plan
        v-bind:team="team">
      </pay-plan>
    </div>
  </div>
</template>

<script>
import LoadingIndicator from 'components/LoadingIndicator';
import DiscountPackage from 'components/billings/packages/DiscountPackage';
import PricingPlan from 'components/billings/pricingPlan/PricingPlan';
import PayPlan from 'components/billings/PayPlan';
import SettingSuspend from 'components/billings/SettingSuspend';

export default {
  components: {
    DiscountPackage,
    PricingPlan,
    PayPlan,
    SettingSuspend,
    LoadingIndicator,
  },
  props: {
    team: {
      type: Object,
    },
  },
  watch: {

  },
  computed: {

  },
  created: function() {
    this.isLoading = true;

    this.$emit('loadChanged', true);
  },
  mounted: function() {

  },
  data: function() {
    return {
      isLoading: false,
    };
  },
  methods: {
    pricingPlanLoadChanged: function(value) {
      this.isLoading = value;
      this.$emit('loadChanged', value);
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CurrentPackage.vue?7dc99aa8